<template>
  <v-footer class="app--footer px-3" inset app>
    <v-spacer></v-spacer>
    <span class="caption"
      >Shelter Group &copy; {{ new Date().getFullYear() }}</span
    >
  </v-footer>
</template>

<script>
export default {
  name: "app-footer"
};
</script>
